<template>
  <div
    ref="partialDiv"
    :class="{
      'container mx-auto': true,
    }"
  >
    <div
      :class="{
        'uss-error-out mt-6': true,
      }"
    >
      <div
        :class="{
          'text-center text-xl font-semibold leading-9 text-www-color-neutral-medium-dark md:text-2xl md:leading-[2.6875rem] lg:text-5xl lg:leading-[5.4rem]': true,
        }"
      >
        {{ title }}
      </div>
      <component
        :is="getComponent(subtitle._type)"
        :value="subtitle"
        :class="{
          'my-6': true,
        }"
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { getComponent } from '~/components/Mapper';
import type UnifiedSignupSessionInfo from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/session-info/UnifiedSignupSessionInfo';
import type SignupSuccessRedirectSignupScreen from '~/hekate-www/external/facets/Form/coordinator/UnifiedSignup/screens/SignupSuccessRedirectSignupScreen';
import type { UssSuccessRedirect } from '~/sanity/types';
import ErrorUtil from '~/hekate-www/external/util/ErrorUtil';

const props = defineProps<
  UssSuccessRedirect & {
    signupScreen: SignupSuccessRedirectSignupScreen;
    sessionInfo: UnifiedSignupSessionInfo;
  }
>();

const emit = defineEmits<{
  hideBackButton: [];
}>();

const partialDiv = ref<HTMLDivElement | null>(null);

onMounted(() => {
  // Hide back button (from initWatchers)
  emit('hideBackButton');

  // Compute redirect URL based on session info (from initListeners)
  let targetLocation = '';
  if (props.signupScreen.isOkEmailOrPro()) {
    targetLocation = 'https://cad.onshape.com/signin';
  }
  if (props.signupScreen.isOkEmailOrEdu()) {
    targetLocation = 'https://cad.onshape.com/upgrade/edu';
  }
  if (!targetLocation) {
    ErrorUtil.internalError({ msg: 'Redirect location is null' });
    return;
  }

  // Update redirect URLs in Sanity content
  const urlElms = partialDiv.value?.querySelectorAll('[data-redirect-url]');
  urlElms?.forEach((elm) => {
    elm.setAttribute('href', targetLocation);
  });

  // Start countdown and redirect
  const countDownElms = partialDiv.value?.querySelectorAll('[data-counter-down]');
  let numSeconds = 4;
  const interval = setInterval(() => {
    numSeconds -= 1;
    countDownElms?.forEach((elm) => {
      elm.textContent = `${numSeconds}`;
      elm.setAttribute('data-counter-down', `${numSeconds}`);
    });

    if (numSeconds > 0) return;
    clearInterval(interval);
    window.location.href = targetLocation;
  }, 1000);
});
</script>

<style></style>
